




































import {Mixins, Component} from 'vue-property-decorator';
import FaqCategoryData from '@/components/board/mixins/FaqCategoryData';
import {GetFaqsPublicFaqNoRequest} from 'supporter';
import {FaqFormData} from '@/types';

@Component
export default class QueryFaqByFaqNo extends Mixins(FaqCategoryData) {
  private formData: FaqFormData = {
    faqCategory: '',
    faqContent: '',
    createdDateTime: '',
    faqTitle: '',
    faqNo: 0
  };

  private close(): void {
    window.close();
  }

  private created(): void {
    document.body.classList.add('popup');
    const resquest: GetFaqsPublicFaqNoRequest = {
      pathParams: {
        faqNo: this.$route.params.faqNo
      }
    };
    this.$api.getFaqsPublicFaqNo(resquest).then((result): void => {
      const {data} = result;
      this.formData = Object.assign({}, this.formData, {...data});
    });
  }
}
